import { blokkieTheme } from '@tikkie/blokkie';
import { ChangeLanguageDropdown } from './change-language-dropdown';

export function LandingHeader() {
  return (
    <header
      style={{
        padding: blokkieTheme.spacing(2),
        position: 'relative',
        left: 0,
        right: 0,
        zIndex: 1,
      }}
    >
      <div
        style={{
          display: 'flex',
          margin: '0 auto',
          justifyContent: 'space-between',
        }}
      >
        <div role="none"></div>

        <ChangeLanguageDropdown />
      </div>
    </header>
  );
}
